import { render, staticRenderFns } from "./ManageForm4.vue?vue&type=template&id=3900f5c2&"
import script from "./ManageForm4.vue?vue&type=script&lang=js&"
export * from "./ManageForm4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports